<template>
  <div>
    <h1 class="mb-4 text-3xl font-bold">
      Mahasiswa
    </h1>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <search-filter
        v-model="form.search"
        class="mr-4 w-full max-w-md"
        placeholder="Cari..."
        @reset="reset">
        <label class="block text-gray-700">Verification Status:</label>
        <select v-model="form.vstatus" class="mt-1 mb-4 w-full form-select">
          <option :value="null">
            ALL STATUS
          </option>
          <option
            v-for="vstatus in verificationStatus"
            :key="vstatus.id"
            :value="vstatus.id">
            {{ vstatus.name }}
          </option>
        </select>
      </search-filter>
      <a
        :href="urlDownload"
        class="mt-2 md:mt-0 btn-green"
        as="button"><i class="fas fa-file-excel" /> Export
        Excel</a>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <tr class="font-bold text-left">
          <th class="px-6 pt-6 pb-4">
            Nama Mahasiswa
          </th>
          <th class="px-6 pt-6 pb-4">
            Status Verifikasi
          </th>
          <th class="px-6 pt-6 pb-4">
            NIM
          </th>
          <th class="px-6 pt-6 pb-4">
            Email
          </th>
          <th class="px-6 pt-6 pb-4">
            No Rekening
          </th>
          <th class="px-6 pt-6 pb-4">
            Bank
          </th>
          <th class="px-6 pt-6 pb-4">
            Kampus
          </th>
          <th class="px-6 pt-6 pb-4" colspan="2">
            Last Update
          </th>
        </tr>
        <tr
          v-for="row in mahasiswa.data"
          :key="row.id"
          class="focus-within:bg-gray-100 hover:bg-gray-100">
          <td class="whitespace-nowrap border-t">
            <inertia-link
              class="flex items-center py-4 px-6 focus:text-indigo-500"
              :href="route('mahasiswa.edit', row.id)">
              {{ row.name }}
              <icon
                v-if="mahasiswa.deleted_at"
                name="trash"
                class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </inertia-link>
          </td>
          <td class="font-bold border-t">
            <inertia-link
              class="flex items-center py-4 px-6 bg-yellow-300 rounded-md hover:bg-indigo-300"
              :href="route('mahasiswa.edit', row.id)"
              tabindex="-1">
              {{ row.vstatus.name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="flex items-center py-4 px-6"
              :href="route('mahasiswa.edit', row.id)"
              tabindex="-1">
              {{ row.nim }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="flex items-center py-4 px-6"
              :href="route('mahasiswa.edit', row.id)"
              tabindex="-1">
              {{ row.email }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="flex items-center py-4 px-6"
              :href="route('mahasiswa.edit', row.id)"
              tabindex="-1">
              {{ row.bank_acc_number }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="flex items-center py-4 px-6"
              :href="route('mahasiswa.edit', row.id)"
              tabindex="-1">
              <span v-if="row.bank">
                {{ row.bank.name }}
              </span>
              <span v-else> [ NO-DATA ] </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="flex items-center py-4 px-6"
              :href="route('mahasiswa.edit', row.id)"
              tabindex="-1">
              <span v-if="row.universitas">
                {{ row.universitas.name }}
              </span>
              <span v-else> [ NO-DATA ] </span>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link
              class="flex items-center py-4 px-6"
              :href="route('mahasiswa.edit', row.id)"
              tabindex="-1">
              {{ row.updated_at }}
            </inertia-link>
          </td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="mahasiswa.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import { router, Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Mahasiswa' },
    components: {
        Icon,
        Pagination,
        SearchFilter,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        filters: Object,
        mahasiswa: Object,
        verificationStatus: Array,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
                trashed: this.filters.trashed,
                vstatus: this.filters.vstatus,
                univ: this.filters.univ,
            },
        }
    },
    computed: {
        urlDownload () {
            return this.form.vstatus
                ? `/mahasiswa/export?vstatus=${this.form.vstatus}`
                : '/mahasiswa/export'
        },
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                router.get(this.route('mahasiswa'), pickBy(this.form), {
                    preserveState: true,
                })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
